import React from 'react';

import { CommonComponentProps } from '../types/components';
import Input from './Input';

/**
 * Utils
 */

/**
 * Types
 */

type Props = React.ComponentProps<typeof Input> & {
    rows?: string;
    cols?: string;
};

/**
 * Styled
 */

/**
 * Component
 */

export default React.forwardRef<
    HTMLTextAreaElement,
    CommonComponentProps<HTMLTextAreaElement> & Props
>(({ ...props }, ref) => <Input as="textarea" innerRef={ref} {...props} />);
